import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import styles from "./EventImagesSection.module.scss";

interface EventImage {
  id: string | number;
  public_link: string;
}

interface EventImagesSectionProps {
  eventImages: EventImage[];
  onRemoveImage: (imageId: string | number) => void;
  onOpenGallery: () => void;
}

export const EventImagesSection = ({
  eventImages,
  onRemoveImage,
  onOpenGallery,
}: EventImagesSectionProps) => {
  return (
    <div className={styles.container}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p style={{ margin: "8px 0" }}>Fotografie k akci</p>
      </div>
      <div className={styles.eventImagesPreview}>
        {eventImages?.length > 0 &&
          eventImages.map((image) => {
            return (
              <div className={styles.previewImageWrapper} key={image.id}>
                <IconButton
                  onClick={() => onRemoveImage(image.id)}
                  className={styles.deleteButtonSmall}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
                <img
                  src={image.public_link}
                  alt={`Obrázek ${image.id}`}
                  width="80px"
                  height="80px"
                  className={styles.previewImage}
                />
              </div>
            );
          })}
        <div className={styles.addImageTileSmall} onClick={onOpenGallery}>
          <AddIcon sx={{ fontSize: 32, color: "#8a2be2" }} />
          <span>Spravovat obrázky</span>
        </div>
      </div>
    </div>
  );
};
